module.exports = __webpack_public_path__ + "img/env_icon3.375c3ded.png";